import {i18n} from "@/app/locale.js";
import {usePage} from "@inertiajs/vue3";
import {setOnboardingTypeDone} from "@/api/onboarding.service.js";
import {userClickedOnboarding, userClosedOnboarding} from "@/api/analytics.service.js";
import {Locales} from "@/shared/enums/Locales.js";
import {createNewToast} from "@/shared/helpers/toast-new.js";
import {emitter, EmitterEvents} from "@/shared/services/Emitter.js";

const onboardingLsKey = "ho2spanish-onboarding";
const setOnboardingToLs = (id) => {
    const onboarding = JSON.parse(localStorage.getItem(onboardingLsKey) || '{}');
    onboarding[id] = true;
    localStorage.setItem(onboardingLsKey, JSON.stringify(onboarding));
}

const getOnboardingFromLs = (id) => {
    const onboarding = JSON.parse(localStorage.getItem(onboardingLsKey) || '{}');
    return onboarding[id] || false;
}

export const getOnboardingKey = (id) => `onboarding_${id}`;

export const showingOnboarding  = {}

const getMessage = (onboardingItem) => {
    const language = i18n.global.locale.value;

    switch (language) {
        case Locales.En:
            return onboardingItem.message_en
        case Locales.Ru:
            return onboardingItem.message_ru
    }

    return onboardingItem.message_es;
}

const executeOnboardingClick = (onboardingItem) => {
    if (!onboardingItem.config?.link) {
        return;
    }

    const isOuterLink = /^https?:\/\//.test(onboardingItem.config.link);

    if (isOuterLink) {
        window.open(onboardingItem.config.link, "_blank", "noopener,noreferrer");
    }
    else {
        window.location.href = onboardingItem.config.link;
    }
}

const getOnboardingItems = (filter) => {
    const page = usePage()
    const onboarding = page.props.onboarding;

    if (!onboarding || onboarding.length === 0) {
        return null;
    }

    return onboarding.filter(filter);
}

const getOnboardingItemsByRoute = () => {
    const path = window.location.pathname;
    const filter = c => c.routes.indexOf(path) >= 0;

    return getOnboardingItems(filter);
}

const getOnboardingItemsByTrigger = (triggerType) => {
    const path = window.location.pathname;
    const filter = c => c.config?.trigger === triggerType;

    return getOnboardingItems(filter);
}

const showOnboarding = (onboardings) => {
    if (!onboardings || onboardings.length === 0) {
        return;
    }

    for (const onboardingItem of onboardings) {
        if (showingOnboarding[onboardingItem.id]) {
            continue
        }

        showingOnboarding[onboardingItem.id] = true;

        if (!onboardingItem.config) {
            console.warn(`onboarding item does not have a proper configuration, configuration id: ${onboardingItem.id}`);
            continue;
        }

        const page = usePage()
        const userOnboarding = getOnboardingFromLs(onboardingItem.id) || page.props?.user?.onboarding?.[getOnboardingKey(onboardingItem.id)];

        if (userOnboarding) {
            continue;
        }

        const onDone = () => {
            delete showingOnboarding[onboardingItem.id]
            setOnboardingToLs(onboardingItem.id)
            setOnboardingTypeDone(onboardingItem.id)
        }

        const toastType = onboardingItem.config.toastType || "info";
        createNewToast(getMessage(onboardingItem), toastType, {
            action: () => {
                userClickedOnboarding(page.props.user, onboardingItem.id);
                onDone();
                executeOnboardingClick(onboardingItem);
            },
            onClose: () => {
                userClosedOnboarding(page.props.user, onboardingItem.id);
                onDone();
            },
            duration: onboardingItem.config?.duration ?? 0
        }).show()
    }
}

export const doOnboarding = () => {
    showOnboarding(getOnboardingItemsByRoute());
}


emitter.on(EmitterEvents.TriggerEvent, triggerType => {
    showOnboarding(getOnboardingItemsByTrigger(triggerType));
})
